module.exports = __webpack_public_path__ + "media/images/siwa/apple_left_white_logo_m-b732c76c12d76898c9a1fffc770a4722.svg";